import { ACTION_TYPES, FETCH_STATUS } from '../Constants';

const initialState = {
  careers: [],
  error: null,
  status: FETCH_STATUS.IDLE,

  gdprModalIsOpen: false,
  subscriptionModalIsOpen: false,
  questionModalIsOpen: false,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case ACTION_TYPES.FETCH_CAREERS_STARTED:
      return {
        ...state,
        status: FETCH_STATUS.FETCHING,
      };
    case ACTION_TYPES.FETCH_CAREERS_SUCCEEDED:
      return {
        ...state,
        careers: action.data,
        status: FETCH_STATUS.SUCCEEDED,
      };
    case ACTION_TYPES.FETCH_CAREERS_FAILED:
      return {
        ...state,
        error: action.error,
        status: FETCH_STATUS.FAILED,
      };
    case ACTION_TYPES.GDPR_MODAL_OPENED:
      return {
        ...state,
        gdprModalIsOpen: true,
      };
    case ACTION_TYPES.GDPR_MODAL_CLOSED:
      return {
        ...state,
        gdprModalIsOpen: false,
      };
    case ACTION_TYPES.SUBSCRIPTION_MODAL_OPENED:
      return {
        ...state,
        subscriptionModalIsOpen: true,
      };
    case ACTION_TYPES.SUBSCRIPTION_MODAL_CLOSED:
      return {
        ...state,
        subscriptionModalIsOpen: false,
      };
    case ACTION_TYPES.QUESTION_MODAL_OPENED:
      return {
        ...state,
        questionModalIsOpen: true,
      };
    case ACTION_TYPES.QUESTION_MODAL_CLOSED:
      return {
        ...state,
        questionModalIsOpen: false,
      };
    default:
      return state;
  }
};

export default reducer;



// WEBPACK FOOTER //
// ./src/Reducers/CareerReducer.js